import React from "react";

const EmptyPage = () => {
    return (
        <div className="results__wrap">
            <div className="results__header">
                <div className="results-header__logo" />
            </div>
            <div className="results__main">
                <h2 className="text-center pt-5">
                    Данные по вашей организации отсутствуют,
                    <br /> отображение невозможно
                </h2>
            </div>
            <div className="results__footer"></div>
        </div>
    );
};

export default EmptyPage;
